import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import LegalPage from "@/pages/LegalPages";
import DemoPage from "@/pages/DemoPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/terminos" element={<LegalPage pageKey="terminos" />} />
          <Route path="/privacidad" element={<LegalPage pageKey="privacidad" />} />
          <Route path="/seguridad" element={<LegalPage pageKey="seguridad" />} />
          <Route path="/devoluciones" element={<LegalPage pageKey="devoluciones" />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;